var render = function() {
  var _vm = this
  var _h = _vm.$createElement
  var _c = _vm._self._c || _h
  return _c("div", { staticClass: "create" }, [
    _c(
      "div",
      {
        directives: [
          {
            name: "loading",
            rawName: "v-loading",
            value: _vm.loadingTpl,
            expression: "loadingTpl"
          }
        ],
        staticClass: "main-box"
      },
      [_c("textarea", { attrs: { id: "tplEditor" } })]
    ),
    _c(
      "div",
      { staticClass: "aside-right" },
      [
        _c("h4", [_vm._v("文件信息")]),
        _c(
          "el-form",
          { staticClass: "contract-info", attrs: { size: "small" } },
          [
            _c(
              "el-form-item",
              [
                _c(
                  "p",
                  {
                    staticClass: "text-center",
                    staticStyle: { "margin-bottom": "10px" }
                  },
                  [_vm._v("文件名称")]
                ),
                _c("el-input", {
                  attrs: {
                    value: _vm.tpl.tplName,
                    placeholder: "模板名称",
                    disabled: true,
                    readonly: true
                  }
                })
              ],
              1
            ),
            _c(
              "el-form-item",
              [
                _c(
                  "el-button",
                  {
                    staticClass: "btn",
                    attrs: { type: "danger", size: "small" },
                    on: {
                      click: function($event) {
                        return _vm.nextStep()
                      }
                    }
                  },
                  [_vm._v("下一步")]
                )
              ],
              1
            ),
            _c("el-form-item", [
              _c("p", { staticClass: "text-center" }, [_vm._v("填写内容")])
            ]),
            _c(
              "div",
              {
                staticStyle: { height: "50vh", overflow: "auto" },
                attrs: { id: "placeholderList" }
              },
              [
                _c(
                  "el-form",
                  {
                    ref: "tplFrm",
                    staticClass: "demo-dynamic",
                    attrs: { model: _vm.tpl }
                  },
                  [
                    _vm.tpl.varList.length
                      ? _c(
                          "div",
                          [
                            _vm._l(_vm.tpl.varList, function(item, i) {
                              return [
                                item.varType === 0
                                  ? _c(
                                      "el-form-item",
                                      {
                                        key: i,
                                        attrs: {
                                          prop: "varList." + i + ".varValue",
                                          rules: [
                                            {
                                              required: item.varIsMust,
                                              message: "请输入文本",
                                              trigger: "change"
                                            },
                                            {
                                              validator:
                                                _vm.$validator.maxLength,
                                              maxLength: 64,
                                              trigger: "change"
                                            }
                                          ]
                                        }
                                      },
                                      [
                                        _c("el-input", {
                                          attrs: {
                                            "data-id": item.varId,
                                            type: "text",
                                            placeholder: item.varName
                                          },
                                          on: {
                                            focus: function($event) {
                                              return _vm.placeholderAddStyle(
                                                item.varId
                                              )
                                            },
                                            blur: function($event) {
                                              return _vm.placeholderDelStyle(
                                                item.varId
                                              )
                                            },
                                            change: function($event) {
                                              return _vm.handleInputChange(i)
                                            }
                                          },
                                          model: {
                                            value: item.varValue,
                                            callback: function($$v) {
                                              _vm.$set(item, "varValue", $$v)
                                            },
                                            expression: "item.varValue"
                                          }
                                        })
                                      ],
                                      1
                                    )
                                  : _vm._e(),
                                item.varType === 1
                                  ? _c(
                                      "el-form-item",
                                      {
                                        key: i,
                                        attrs: {
                                          prop: "varList." + i + ".varValue",
                                          rules: [
                                            {
                                              required: item.varIsMust,
                                              message: "请输入数字",
                                              trigger: "change"
                                            },
                                            {
                                              validator: _vm.$validator.number,
                                              message: "请输入数值",
                                              trigger: "change",
                                              emptyAble: true
                                            },
                                            {
                                              validator:
                                                _vm.$validator.maxLength,
                                              maxLength: 32,
                                              trigger: "change"
                                            }
                                          ]
                                        }
                                      },
                                      [
                                        _c("el-input", {
                                          attrs: {
                                            "data-id": item.varId,
                                            type: "text",
                                            placeholder: item.varName
                                          },
                                          on: {
                                            focus: function($event) {
                                              return _vm.placeholderAddStyle(
                                                item.varId
                                              )
                                            },
                                            blur: function($event) {
                                              return _vm.placeholderDelStyle(
                                                item.varId
                                              )
                                            },
                                            change: function($event) {
                                              return _vm.handleInputChange(i)
                                            }
                                          },
                                          model: {
                                            value: item.varValue,
                                            callback: function($$v) {
                                              _vm.$set(item, "varValue", $$v)
                                            },
                                            expression: "item.varValue"
                                          }
                                        })
                                      ],
                                      1
                                    )
                                  : _vm._e(),
                                item.varType === 2
                                  ? _c(
                                      "el-form-item",
                                      {
                                        key: i,
                                        attrs: {
                                          prop: "varList." + i + ".varValue",
                                          rules: [
                                            {
                                              required: item.varIsMust,
                                              message: "请输入日期",
                                              trigger: "change"
                                            },
                                            {
                                              validator: _vm.$validator.regex,
                                              regex: /^(\d{4}-\d{2}-\d{2})?$/,
                                              message: "请选择正确的日期",
                                              trigger: "change",
                                              emptyAble: true
                                            }
                                          ]
                                        }
                                      },
                                      [
                                        _c("el-date-picker", {
                                          attrs: {
                                            "popper-class": "date-popper-cls",
                                            "value-format": "yyyy-MM-dd",
                                            align: "left",
                                            "data-id": item.varId,
                                            type: "date",
                                            placeholder: item.varName
                                          },
                                          on: {
                                            focus: function($event) {
                                              return _vm.placeholderAddStyle(
                                                item.varId
                                              )
                                            },
                                            blur: function($event) {
                                              return _vm.placeholderDelStyle(
                                                item.varId
                                              )
                                            },
                                            change: function($event) {
                                              return _vm.handleInputChange(i)
                                            }
                                          },
                                          model: {
                                            value: item.varValue,
                                            callback: function($$v) {
                                              _vm.$set(item, "varValue", $$v)
                                            },
                                            expression: "item.varValue"
                                          }
                                        })
                                      ],
                                      1
                                    )
                                  : _vm._e(),
                                item.varType === 3
                                  ? _c(
                                      "el-form-item",
                                      {
                                        key: i,
                                        attrs: {
                                          prop: "varList." + i + ".varValue",
                                          rules: [
                                            {
                                              required: item.varIsMust,
                                              message: "请输入手机号",
                                              trigger: "change"
                                            },
                                            {
                                              validator: _vm.$validator.mobile,
                                              trigger: "change",
                                              emptyAble: true
                                            },
                                            {
                                              validator:
                                                _vm.$validator.maxLength,
                                              maxLength: 20,
                                              trigger: "change"
                                            }
                                          ]
                                        }
                                      },
                                      [
                                        _c("el-input", {
                                          attrs: {
                                            "data-id": item.varId,
                                            type: "text",
                                            placeholder: item.varName
                                          },
                                          on: {
                                            focus: function($event) {
                                              return _vm.placeholderAddStyle(
                                                item.varId
                                              )
                                            },
                                            blur: function($event) {
                                              return _vm.placeholderDelStyle(
                                                item.varId
                                              )
                                            },
                                            change: function($event) {
                                              return _vm.handleInputChange(i)
                                            }
                                          },
                                          model: {
                                            value: item.varValue,
                                            callback: function($$v) {
                                              _vm.$set(item, "varValue", $$v)
                                            },
                                            expression: "item.varValue"
                                          }
                                        })
                                      ],
                                      1
                                    )
                                  : _vm._e(),
                                item.varType === 4
                                  ? _c(
                                      "el-form-item",
                                      {
                                        key: i,
                                        attrs: {
                                          prop: "varList." + i + ".varValue",
                                          rules: [
                                            {
                                              required: item.varIsMust,
                                              message: "请输入身份证号",
                                              trigger: "change"
                                            },
                                            {
                                              validator: _vm.$validator.idCard,
                                              trigger: "change",
                                              emptyAble: true
                                            }
                                          ]
                                        }
                                      },
                                      [
                                        _c("el-input", {
                                          attrs: {
                                            "data-id": item.varId,
                                            type: "text",
                                            placeholder: item.varName
                                          },
                                          on: {
                                            focus: function($event) {
                                              return _vm.placeholderAddStyle(
                                                item.varId
                                              )
                                            },
                                            blur: function($event) {
                                              return _vm.placeholderDelStyle(
                                                item.varId
                                              )
                                            },
                                            change: function($event) {
                                              return _vm.handleInputChange(i)
                                            }
                                          },
                                          model: {
                                            value: item.varValue,
                                            callback: function($$v) {
                                              _vm.$set(item, "varValue", $$v)
                                            },
                                            expression: "item.varValue"
                                          }
                                        })
                                      ],
                                      1
                                    )
                                  : _vm._e(),
                                item.varType === 5
                                  ? _c(
                                      "el-form-item",
                                      {
                                        key: i,
                                        attrs: {
                                          prop: "varList." + i + ".varValue",
                                          rules: [
                                            {
                                              required: item.varIsMust,
                                              message: "请输入营业执照号",
                                              trigger: "change"
                                            },
                                            {
                                              validator:
                                                _vm.$validator
                                                  .businessLicenseVal,
                                              trigger: "change",
                                              emptyAble: true
                                            }
                                          ]
                                        }
                                      },
                                      [
                                        _c("el-input", {
                                          attrs: {
                                            "data-id": item.varId,
                                            type: "text",
                                            placeholder: item.varName
                                          },
                                          on: {
                                            focus: function($event) {
                                              return _vm.placeholderAddStyle(
                                                item.varId
                                              )
                                            },
                                            blur: function($event) {
                                              return _vm.placeholderDelStyle(
                                                item.varId
                                              )
                                            },
                                            change: function($event) {
                                              return _vm.handleInputChange(i)
                                            }
                                          },
                                          model: {
                                            value: item.varValue,
                                            callback: function($$v) {
                                              _vm.$set(item, "varValue", $$v)
                                            },
                                            expression: "item.varValue"
                                          }
                                        })
                                      ],
                                      1
                                    )
                                  : _vm._e(),
                                item.varType === 6
                                  ? _c(
                                      "el-form-item",
                                      {
                                        key: i,
                                        attrs: {
                                          prop: "varList." + i + ".varValue",
                                          rules: [
                                            {
                                              required: item.varIsMust,
                                              message: "请输入统一社会编码格式",
                                              trigger: "change"
                                            },
                                            {
                                              validator:
                                                _vm.$validator
                                                  .businessLicenseVal,
                                              trigger: "change",
                                              emptyAble: true
                                            }
                                          ]
                                        }
                                      },
                                      [
                                        _c("el-input", {
                                          attrs: {
                                            "data-id": item.varId,
                                            type: "text",
                                            placeholder: item.varName
                                          },
                                          on: {
                                            focus: function($event) {
                                              return _vm.placeholderAddStyle(
                                                item.varId
                                              )
                                            },
                                            blur: function($event) {
                                              return _vm.placeholderDelStyle(
                                                item.varId
                                              )
                                            },
                                            change: function($event) {
                                              return _vm.handleInputChange(i)
                                            }
                                          },
                                          model: {
                                            value: item.varValue,
                                            callback: function($$v) {
                                              _vm.$set(item, "varValue", $$v)
                                            },
                                            expression: "item.varValue"
                                          }
                                        })
                                      ],
                                      1
                                    )
                                  : _vm._e(),
                                item.varType === 7
                                  ? _c(
                                      "el-form-item",
                                      {
                                        key: i,
                                        attrs: {
                                          prop: "varList." + i + ".varValue",
                                          rules: [
                                            {
                                              required: item.varIsMust,
                                              message: "请输入邮箱",
                                              trigger: "change"
                                            },
                                            {
                                              validator: _vm.$validator.email,
                                              trigger: "change",
                                              emptyAble: true
                                            },
                                            {
                                              validator:
                                                _vm.$validator.maxLength,
                                              maxLength: 64,
                                              trigger: "change"
                                            }
                                          ]
                                        }
                                      },
                                      [
                                        _c("el-input", {
                                          attrs: {
                                            "data-id": item.varId,
                                            type: "text",
                                            placeholder: item.varName
                                          },
                                          on: {
                                            focus: function($event) {
                                              return _vm.placeholderAddStyle(
                                                item.varId
                                              )
                                            },
                                            blur: function($event) {
                                              return _vm.placeholderDelStyle(
                                                item.varId
                                              )
                                            },
                                            change: function($event) {
                                              return _vm.handleInputChange(i)
                                            }
                                          },
                                          model: {
                                            value: item.varValue,
                                            callback: function($$v) {
                                              _vm.$set(item, "varValue", $$v)
                                            },
                                            expression: "item.varValue"
                                          }
                                        })
                                      ],
                                      1
                                    )
                                  : _vm._e()
                              ]
                            })
                          ],
                          2
                        )
                      : _vm._e()
                  ]
                )
              ],
              1
            )
          ],
          1
        )
      ],
      1
    )
  ])
}
var staticRenderFns = []
render._withStripped = true
var esExports = { render: render, staticRenderFns: staticRenderFns }
export default esExports
if (module.hot) {
  module.hot.accept()
  if (module.hot.data) {
    require("vue-hot-reload-api")      .rerender("data-v-6de6e278", esExports)
  }
}


//////////////////
// WEBPACK FOOTER
// ./node_modules/vue-loader/lib/template-compiler?{"id":"data-v-6de6e278","hasScoped":true,"transformToRequire":{"video":"src","source":"src","object":"src","embed":"src"},"preserveWhitespace":false,"buble":{"transforms":{}}}!./node_modules/vue-loader/lib/selector.js?type=template&index=0!./pages/tpl/add/apply.vue
// module id = XU15
// module chunks = 217